export default (opacity) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: 8,
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  ':before': {
    content: '""',
    backgroundColor: '#000',
    opacity,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  '>*': {
    cursor: 'auto',
    pointerEvents: 'auto',
    position: 'relative',
  },
});
